// @ts-strict-ignore
/**
 * @fileoverview POST handler for the "/apps/:app_group_id/push_settings" endpoint
 */
import fetch from "@lib/fetch";
import sharedConstants from "@lib/shared_constants";

import type { EngagementAppGroupIdPushSettingsResult } from "../engagementAppGroupIdPushSettings";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdPushSettingsCacheKeys } from "./constants";
import type { PostAppsAppGroupIdPushSettingsProps, AppsAppGroupIdPushSettingsResult } from "./types";

export const postAppsAppGroupIdPushSettings = reactQueryMutationAdapter(
  appsAppGroupIdPushSettingsCacheKeys,
  (props: PostAppsAppGroupIdPushSettingsProps): Promise<AppsAppGroupIdPushSettingsResult> => {
    const {
      androidDefaultTimeToLive,
      kindleDefaultTimeToLive,
      webDefaultTimeToLive,
      huaweiDefaultTimeToLive,
      defaultFcmDeliveryPriority,
    } = props;

    const requestBody: EngagementAppGroupIdPushSettingsResult = {
      ...((androidDefaultTimeToLive || androidDefaultTimeToLive === 0) && {
        android_default_time_to_live: androidDefaultTimeToLive,
      }),
      ...((kindleDefaultTimeToLive || kindleDefaultTimeToLive === 0) && {
        kindle_default_time_to_live: kindleDefaultTimeToLive,
      }),
      ...((webDefaultTimeToLive || webDefaultTimeToLive === 0) && {
        web_default_time_to_live: webDefaultTimeToLive,
      }),
      ...((huaweiDefaultTimeToLive || huaweiDefaultTimeToLive === 0) && {
        huawei_default_time_to_live: huaweiDefaultTimeToLive,
      }),
      ...(defaultFcmDeliveryPriority &&
        Object.values(sharedConstants.ANDROID_FIREBASE_PUSH_SENDER_PRIORITIES).includes(
          defaultFcmDeliveryPriority
        ) && {
          default_fcm_delivery_priority: defaultFcmDeliveryPriority,
        }),
    };

    return fetch(`/apps/${props.appGroupId}/push_settings`, "POST", requestBody);
  }
);
